export var textxs = { "fontSize": "10px" };
export var textsm = { "fontSize": "12px" };
export var textbase = { "fontSize": "15px" };
export var textlg = { "fontSize": "18px" };
export var textxl = { "fontSize": "22px" };
export var text2xl = { "fontSize": "26px" };
export var text3xl = { "fontSize": "31px" };
export var text4xl = { "fontSize": "37px" };
export var text5xl = { "fontSize": "45px" };
export var text6xl = { "fontSize": "54px" };
//# sourceMappingURL=typography-next.js.map